import React, { useEffect, useState } from "react";
import { client } from "../../../client";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import TopBar from "../../../components/TopBar/TopBar";
import Navbar from "../../../components/Navbar/Navbar";

import Button from "../../../components/Button/Button";
import PortableText from "react-portable-text";

import Gif from "../../../Images/Add a heading.png";

import TopBarSingleProject from "../../../components/TopBar/TopBarSingleProject";

const ProjectWebDevSingle = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "Web Development - Shreeyash Parsawar | Portfolio";
  }, []);

  // api featch section

  const [oneProjectwevdevdata, setOneProjectwevdevdata] = useState(null);

  const { slug } = useParams();

  useEffect(() => {
    const query = `*[slug.current == $slug]{
          projectname,
          slug,
          projectdesc,
          projectvideolink,
          projectlink,
          projectprotypelink,
          projecttechname1,
          projecttechname2,
          projecttechname3,
          projecttechname4,
          projecttoolname1,
          projecttoolname2,
          projecttoolname3,
          projecttoolname4,
          projecttoolimg1{
              asset->{
                  _id,
                  url
              }
          },
          projecttoolimg2{
              asset->{
                  _id,
                  url
              }
          },
          projecttoolimg3{
              asset->{
                  _id,
                  url
              }
          },
          projecttoolimg4{
              asset->{
                  _id,
                  url
              }
          },
          projecttechimg1{
              asset->{
                  _id,
                  url
              }
          },
          projecttechimg2{
              asset->{
                  _id,
                  url
              }
          },
          projecttechimg3{
              asset->{
                  _id,
                  url
              }
          },
          projecttechimg4{
              asset->{
                  _id,
                  url
              }
          },

      }`;

    client.fetch(query, { slug }).then((data) => {
      setOneProjectwevdevdata(data[0]);
      console.log(data);
    });
  }, [slug]);

  if (!oneProjectwevdevdata) return <div className="spinner"></div>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      <section className="sectionProjectWevdev ">
        <TopBarSingleProject />
        <div className="container pt-5  text-center">
          <h1 className="card-title project_title">
            {oneProjectwevdevdata.projectname}
          </h1>
        </div>

        <div className="container-fluid mt-5 px-5 pb-5">
          <div className="row">
            {/* =============================== Technology ================================= */}

            <div className="col-lg-6 text-left">
              <h1 className="project_title">Technologys:</h1>

              {/* ------------------------------------------------ */}

              <div className="container-fluid">
                <div className="row">
                  {/* Technology 1 section  */}

                  {oneProjectwevdevdata.projecttechimg1 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttechimg1.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttechname1}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Technology 1 section  */}

                  {/* ======================================================================= */}

                  {/* Technology 2 section  */}

                  {oneProjectwevdevdata.projecttechimg2 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttechimg2.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttechname2}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Technology 2 section  */}

                  {/* ======================================================================= */}

                  {/* Technology 3 section  */}

                  {oneProjectwevdevdata.projecttechimg3 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttechimg3.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttechname3}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Technology 3 section  */}

                  {/* ======================================================================= */}

                  {/* Technology 4 section  */}

                  {oneProjectwevdevdata.projecttechimg4 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttechimg4.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttechname4}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* tool 4 section  */}

                  {/* ======================================================================= */}
                </div>
              </div>

              {/* ------------------------------------------------ */}
            </div>

            {/* --------------------------------- Impportant Part Further Need use ---------------------------- */}

          
            
            {/* --------------------Add this in when u featch the data----------------
            
             projecttoolname5[]{
            file{
              asset->{
                  _id,
                  url
              }
          }
          },

          ------------------------------------
            
            <div className="col-lg-3">
              {oneProjectwevdevdata.projecttoolname5 &&
                oneProjectwevdevdata.projecttoolname5.map((item, index) => (
                  <img
                    key={index}
                    src={item.file.asset.url}
                    className="img-fluid"
                  />
                ))}
            </div>  */}

            {/* --------------------------------- demo ---------------------------- */}

            {/* =============================== Technology ================================= */}

            {/* =============================== Project Vedio  ================================= */}

            <div className="col-lg-6 px-5 text-center">
              <div className="mockup-container">
                <img
                  src={
                    oneProjectwevdevdata.projectvideolink === null
                      ? Gif
                      : oneProjectwevdevdata.projectvideolink
                  }
                  alt="Computer Screen Mockup"
                  className="mockup-image img-fluid"
                  // style={{width:'400px', height:'200px'}}
                />
              </div>

              <div className="container-fluid mt-3">
                <div className="row">
                  <div className="col-lg-6 mt-3">
                    <Link to={oneProjectwevdevdata.projectlink} target="_blank">
                      <Button title=" Live Project" />
                    </Link>
                  </div>

                  <div className="col-lg-6 mt-3">
                    <Link
                      to={oneProjectwevdevdata.projectprotypelink}
                      target="_blank"
                    >
                      <Button title=" Protype Project" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* =============================== Project Vedio  ================================= */}

            {/* =============================== Project Descrtiption ================================= */}

            <div className="col-lg-12 text-left">
              <h1 className="project_title">Description:</h1>

              <p className="project_desc">{oneProjectwevdevdata.projectdesc}</p>
            </div>

            {/* =============================== Project Descrtiption ================================= */}

            {/* =============================== Tools ================================= */}

            <div className="col-lg-12 text-left">
              <h1 className="project_title">Tools:</h1>

              {/* ------------------------------------------------ */}

              <div className="container-fluid">
                <div className="row">
                  {/* tool 1 section  */}

                  {oneProjectwevdevdata.projecttoolimg1 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttoolimg1.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttoolname1}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* tool 1 section  */}

                  {/* ======================================================================= */}

                  {/* tool 2 section  */}

                  {oneProjectwevdevdata.projecttoolimg2 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttoolimg2.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttoolname2}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* tool 2 section  */}

                  {/* ======================================================================= */}

                  {/* tool 3 section  */}

                  {oneProjectwevdevdata.projecttoolimg3 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttoolimg3.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttoolname3}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* tool 3 section  */}

                  {/* ======================================================================= */}

                  {/* tool 4 section  */}

                  {oneProjectwevdevdata.projecttoolimg4 === null ? (
                    ""
                  ) : (
                    <>
                      <div className="col-lg-3 col-md-6 col-12">
                        <div className="skill--box">
                          <img
                            src={oneProjectwevdevdata.projecttoolimg4.asset.url}
                            alt=""
                          />

                          <h3 className="project_title">
                            {oneProjectwevdevdata.projecttoolname4}
                          </h3>
                        </div>
                      </div>
                    </>
                  )}

                  {/* tool 4 section  */}

                  {/* ======================================================================= */}
                </div>
              </div>

              {/* ------------------------------------------------ */}
            </div>

            {/* =============================== Tools ================================= */}
          </div>
        </div>
      </section>

      {/* <Navbar /> */}
    </motion.div>
  );
};

export default ProjectWebDevSingle;
